import { createSlice } from "@reduxjs/toolkit";

// Initial state
const initialState = {
  expiryDate: null,
};

// Slice
const sessionSlice = createSlice({
  name: "session",
  initialState,
  reducers: {
    setSessionDate(state, action) {
      const { expiryDate } = action.payload;
      return { ...state, expiryDate };
    },
  },
});

export const { setSessionDate } = sessionSlice.actions;

export default sessionSlice.reducer;
